import styled from 'vue-styled-components';
import { prop } from 'ramda';

import { FONTS } from '../../../constants';
import { COLORS } from '../../../colors';

export const ChartHover = styled.g`
  cursor: pointer;
`;

export const SeriesContainer = styled.g``;

export const CircleElement = styled.circle``;

export const FilteredData = styled.g`
  path {
    stroke-dasharray: none;
  }
`;

export const TotalText = styled('text', { color: String, default: COLORS.MAKO })`
  font-size: 16px;
  font-weight: normal;
  font-family: ${FONTS.KNOCKOUT_50_FONT};
  text-anchor: end;
  fill: ${prop('color')};
`;
